import { FunctionComponent } from 'react';
import { Button } from 'react-bootstrap';

export interface AButtonProps
{
    /** The text of the button. */
    text: string;
    /** The link of the button. Optional if onClick is provided. */
    link?: string;
    /** The size of the button. */
    size?: 'sm' | 'lg';
    /** The icon of the button. */
    icon?: string;
    /** The target of the button. */
    target?: '_blank' | '_self' | '_parent' | '_top';
    /** The variant of the button. */
    variant?: 'primary' | 'secondary' | 'outline-primary' | 'outline-secondary';
    /** The text color of the button. */
    textColor?: 'body' | 'white';
    /** The class name of the button. */
    className?: string;
    /** The onClick handler for the button. */
    onClick?: () => void;
}

/**
 * Component: a button that can be used across the website.
 */
const AButton: FunctionComponent<AButtonProps> = (props) =>
{
    const size = props.size ?? 'lg';

    /** Render */
    return (
        <>
            <Button
                href={props.link}
                onClick={props.onClick}
                variant={props.variant ?? 'outline-primary'}
                target={props.link ? props.target : undefined}
                className={ `a-button text-uppercase ${size} ${props.className}` }
            >
                {props.icon && <i className={`${props.icon} me-2`}></i>}
                <span className={`a-button-text ${props.textColor === 'white' ? 'text-white' : ''}`}>
                    {props.text}
                </span>
            </Button>
        </>
    );
}

export default AButton;